import { Typography } from '@mui/material';
import { FC } from 'react';

type BoostNoteProps = {
  color?: string;
};

const BoostNote: FC<BoostNoteProps> = ({ color = 'lightPurple.main' }) => {
  return (
    <Typography variant="body2" px={6} color={color}>
      *Please note that cost performance can vary by market and job positions.
      An Influx in applications is not always guaranteed.
    </Typography>
  );
};

export default BoostNote;
